/**
 * The mock's shared mutable state — what the prototype kept in its dashboard
 * reducer and every module read. Lives for the page session (a reload resets
 * it, as in the prototype). Owned by the conversations feature.
 *
 * Only Tune sentiment's corrections live here, because they are the one piece
 * of state *every* widget reads: `query.ts` applies them where rows enter the
 * mock, so no loader can forget to honour a correction. Per-domain state goes
 * in `mock/<domain>/db.ts`.
 */
import type { RowId, SentimentOverrides } from './engine/sentimentOverrides';

type MockDb = {
  sentimentOverrides: SentimentOverrides;
};

export const db: MockDb = {
  sentimentOverrides: {},
};

/**
 * The prototype reducer's `saveSentimentOverrides`: a merge, not a
 * replacement — a save carries only the posts edited in that session of the
 * modal, and earlier corrections must survive it. A new object either way.
 */
export function saveSentimentOverrides(changes: Readonly<Record<RowId, string>>): void {
  db.sentimentOverrides = { ...db.sentimentOverrides, ...changes };
}
